export default __webpack_public_path__ + "static/media/tuesat.357e11f5.png";